import {
  ConsultantViewerReference,
  ViewerAddress,
  ViewerPhone,
} from '../../../../core/models/api.models';

const numberFormatter = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatText(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return '-';
  }

  const text = value.toString().trim();
  return text ? text : '-';
}

export function formatDate(value: string | null | undefined): string {
  if (!value?.trim()) {
    return '-';
  }

  return value
    .replace('T00:00:00.0000000', '')
    .replace('T00:00:00.000', '')
    .replace('T00:00:00', '')
    .replace('T', ' ');
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '-';
  }

  return numberFormatter.format(value);
}

export function formatPercentage(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '-';
  }

  return `${numberFormatter.format(value)} %`;
}

export function formatBoolean(value: boolean | null | undefined): string {
  if (value === null || value === undefined) {
    return '-';
  }

  return value ? 'Oui' : 'Non';
}

export function formatIdentity(
  lastName?: string | null,
  firstName?: string | null,
  fallback?: string,
): string {
  const label = [lastName, firstName]
    .map((value) => value?.trim())
    .filter((value): value is string => !!value)
    .join(' ');

  return label || fallback || '-';
}

export function formatConsultantReference(
  reference?: ConsultantViewerReference | null,
): string {
  if (!reference) {
    return '-';
  }

  const fallback = reference.consultantName ?? reference.consultantCode ?? undefined;

  return (
    formatIdentity(undefined, undefined, fallback) ||
    `Consultant #${reference.consultantId}`
  );
}

export function formatAddress(address: ViewerAddress): string {
  return [
    address.address1,
    address.address2,
    address.address3,
    address.complement,
    joinWithSeparator(' ', address.zipCode, address.city),
    address.cedex,
    address.countryCode,
  ]
    .map((value) => value?.trim())
    .filter((value): value is string => !!value)
    .join(' • ') || '-';
}

export function formatPhone(phone: ViewerPhone): string {
  return joinWithSeparator(' ', phone.prefix, phone.number) || '-';
}

function joinWithSeparator(
  separator: string,
  ...values: Array<string | null | undefined>
): string {
  return values
    .map((value) => value?.trim())
    .filter((value): value is string => !!value)
    .join(separator);
}
